import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTwitter } from '@fortawesome/free-brands-svg-icons';


export default ({ isAuthenticated, current }) => (
    <footer className="footer">
        <div className="container">
            <div className="content has-text-grey has-text-centered">
                <div className="columns is-mobile is-multiline is-centered">
                    <div className="column is-6-mobile is-2-desktop">
                        <Link to="/aboutus">
                            <h5 className="is-size-6">About Us</h5>
                        </Link>
                    </div>
                    <div className="column is-6-mobile is-2-desktop">
                        <Link to="/contactus">
                            <h5 className="is-size-6">Contact Us</h5>
                        </Link>
                    </div>
                    <div className="column is-6-mobile is-2-desktop">
                        <Link to="/termsofuse">
                            <h5 className="is-size-6">Terms of Use</h5>
                        </Link>
                    </div>
                    <div className="column is-6-mobile is-2-desktop">
                        <Link to="/privacypolicy">
                            <h5 className="is-size-6">Privacy Policy</h5>
                        </Link>
                    </div>
                </div>
                <div className="has-text-grey-light footer-social-title">Follow Us</div>
                <div className="footer-social">
                    <a href="https://www.facebook.com/pages/Myhomekart/1570553156559548"><FontAwesomeIcon icon={faFacebookF} fixedWidth /></a>
                    <a href="https://twitter.com/myhomekart"><FontAwesomeIcon icon={faTwitter} fixedWidth /></a>
                </div>
                <hr style={{ backgroundColor: 'rgba(255,255,255,.05)' }} />
                <p className="has-text-grey has-text-centered">
                    Copyrights © 2018 Raavas Realtors Private Limited
                    <br />
                    RERA NO: A51700005763</p>
            </div>
        </div>
    </footer>
)


// WEBPACK FOOTER //
// ./src/app/footer.js